import {get} from "lodash";
import axios from 'axios';
import * as qs from 'qs';
import {Resource} from 'i18next';
import SiteHeader from './compontents/site-header';
import Dropdown from './compontents/dropdown';
import * as LazyLoad from 'vanilla-lazyload/dist/lazyload';
import * as i18next from 'i18next/i18next.js';
import Modal from "./compontents/modal";
import ViewPort from "./viewport";
import Tabs from "./compontents/tabs";
import blocks from '../../blocks/js/blocks';
import Gallery from "./compontents/gallery";
//import * as Vue from 'vue/dist/vue';
import * as Glide from '@glidejs/glide/dist/glide';
//import Glide, { Controls, Breakpoints } from '@glidejs/glide/dist/glide.modular.esm'

/*const glide = new Glide('.glide', {
  type: 'slider',
  focusAt: 'center',
  startAt: 0,
  perView: 4
});
glide.mount();*/


declare global {
  interface Window {
    pp: {
      data: Record<string, any>;
      translations: Record<string, any>;
    };
  }
}
declare let __webpack_public_path__: string;

export default class App {
  static instance: App;

  static init(): void {
    if (!App.instance) {
      App.instance = new App();
    }
  }

  constructor() {
    App._loadTranslations();

    ViewPort.setBreakpoints({
      xs: 0,
      sm: 540,
      md: 768,
      lg: 1024,
      xl: 1200
    });

    __webpack_public_path__ = App.getData('publicPath');

    axios.defaults.baseURL = App.getData('ajaxUrl');
    axios.interceptors.request.use(config => {
      config.paramsSerializer = params => qs.stringify(params);
      return config;
    });

    window.addEventListener('load', () => {
      new SiteHeader(document.querySelector('._js-header'));
    });

    new LazyLoad();

    const slider = document.querySelector('.glide-slider');

    if (slider) {
      /*const glide = new Glide(slider, {
        type: 'carousel',
        perView: 1
      });

      glide.mount();*/
    }
    const slider_related = document.querySelector('#related');

    if (slider_related) {
      const related = new Glide('#related', {
        type: 'slider',
        focusAt: '1',
        startAt: 0,
        perView: 5,
        breakpoints: {
          2348: {
            perView: 7,
            startAt: 1,
            focusAt: '2'
          },
          2054: {
            perView: 6,
            startAt: 1,
            focusAt: '1'
          },
          1761: {
            perView: 6,
            startAt: 1,
            focusAt: '1'
          },
          1467: {
            perView: 5,
            startAt: 1,
            focusAt: '1'
          },
          1174: {
            perView: 4,
            startAt: 1,
            focusAt: '0'
          },
          880: {
            perView: 3,
            startAt: 1,
            focusAt: '0'
          },
          587: {
            perView: 2,
            focusAt: '0',
            startAt: 1
          }
        }
      });
      related.mount();
    }
    const slider_upsells = document.querySelector('#upsells');

    if (slider_upsells) {
      const upsells = new Glide('#upsells', {
        type: 'slider',
        focusAt: '3',
        startAt: 0,
        perView: 10,
        slideWidth:260,
        wrapperWidth:1000, 
        gap: 30,
        breakpoints: {
          2348: {
            perView: 7,
            startAt: 1,
            focusAt: '2'
          },
          2054: {
            perView: 6,
            startAt: 1,
            focusAt: '1'
          },
          1761: {
            perView: 6,
            startAt: 1,
            focusAt: '1'
          },
          1467: {
            perView: 5,
            startAt: 1,
            focusAt: '1'
          },
          1174: {
            perView: 4,
            startAt: 1,
            focusAt: '0'
          },
          880: {
            perView: 3,
            startAt: 1,
            focusAt: '0'
          },
          587: {
            perView: 2,
            focusAt: '0',
            startAt: 1
          }
        }
      });
      upsells.mount();
    }

    const slider_cross_sells = document.querySelector('#cross_sells');

    if (slider_cross_sells) {
      const cross_sells = new Glide('#cross_sells', {
        type: 'slider',
        focusAt: '1',
        startAt: 0,
        perView: 4,
        breakpoints: {
          1024: {
            perView: 2
          },
          600: {
            perView: 2,
            focusAt: '0',
            startAt: 1,
          }
        }
      });
      cross_sells.mount();
    }

    const slider_employees = document.querySelector('#options-focus-at');

    if (slider_employees) {
      const employees = new Glide('#options-focus-at', {
        type: 'slider',
        focusAt: '1',
        startAt: 0,
        perView: 5,
        breakpoints: {
          1024: {
            perView: 4
          },
          600: {
            perView: 1,
            focusAt: '0',
            startAt: 1,
          }
        }
      });
      employees.mount();
    }

    const buttonSwitch = document.getElementById('switch');

    if (buttonSwitch) {
        const switchPrivat = document.getElementById('switch-privat');
        const switchBederiftskunde = document.getElementById('switch-bederiftskunde');
        const textB2b = document.getElementById('text_b2b');
        const textB2c = document.getElementById('text_b2c');
        buttonSwitch.addEventListener('click', (event) => {
          if (buttonSwitch.classList.contains('toggled')) {
              buttonSwitch.setAttribute('aria-checked', 'false');
          }
          else {
            buttonSwitch.setAttribute('aria-checked', 'true');
          }
          textB2b.classList.toggle('toggled');
          textB2c.classList.toggle('toggled');
          switchPrivat.classList.toggle('toggled');
          switchBederiftskunde.classList.toggle('toggled');
          buttonSwitch.classList.toggle('toggled');
        });
    }
    const menuHasChild = document.querySelectorAll('ul.nav li.menu-item ul.dropdown-menu li.menu-item-has-children');
      menuHasChild.forEach((item) => {
        item.addEventListener('click', (e) => {
            e.target.classList.toggle('toggled');
        })
    });
    const menuHasChildLevel3 = document.querySelectorAll('ul.nav li.menu-item ul.dropdown-menu li.menu-item-has-children ul.dropdown-menu li.menu-item-has-children');
    menuHasChildLevel3.forEach((item) => {
      item.addEventListener('click', (e) => {
          e.target.classList.toggle('toggled');
      })
  });
    let attributeItem = document.querySelectorAll('.attr_item');
    const attributeSelect = document.querySelectorAll('.attribute_select');
    if (attributeSelect) {
      attributeSelect.forEach((item) => {
        item.addEventListener('change', (e) => {
            const attrItem = document.getElementById(e.target.name);
            if (attrItem) {
              attrItem.innerHTML = e.target.value;
            }
            else {
              const selectAttr = document.getElementById("add_to_me").innerHTML += '<span id="'+e.target.name+'" class="attr_item">'+e.target.value+'</span>';
            }
            attributeItem = document.querySelectorAll('.attr_item');
            console.log(attributeItem);
            App.showAttribute(attributeItem);
        })
      });
    }

    jQuery('#yith-ywraq-form').submit(function(){
      jQuery(this).find(':input[type=submit]').prop('disabled', true);
    });

    //Request input file 
    const fileInput = document.querySelector(".custom-file-input");
    const fileList = document.querySelector(".files-list");

    if(fileList){
      fileInput.addEventListener("click", () => {
        fileInput.value = '';
      });


      fileInput.addEventListener("change", e => {
        for(const file of fileInput.files){
          fileList.innerHTML += "<span class='file-name'>" + file.name + "<span class='file-size'>" +(file.size/1024).toFixed(1) + " KB </span></span>";
        }
      });

    }

    blocks();
    //Modal.factory();
    Tabs.factory();
    //Gallery.factory();
    //Dropdown.factory();
    Glide();
    
  }

  public static getData(key: string): any {
    return get(window.pp.data, key);
  }

  private static _loadTranslations(): void {
    const translationResources: Resource = {};
    translationResources[App.getData('lang')] = {
      translation: window.pp.translations
    };

    i18next.init({
      lng: App.getData('lang'),
      initImmediate: false,
      resources: translationResources
    });
  }

  public static showAttribute(attributeItem): void {
    if (attributeItem) {
      attributeItem.forEach((item) => {
        item.addEventListener('click', (e) => {
          //console.log(e.target);
          const idSelect = e.target.id.split('attribute_')[1];
          const removeItem = document.getElementById(e.target.id).remove();
          const selectItem = document.getElementById(idSelect);
          selectItem.addEventListener('change', (e) => {
            //selectItem.selectedIndex = 0;
            //selectItem.click();
            //console.log('1');
          });
          selectItem.selectedIndex = 0;
          //selectItem.click();
          //selectItem.value = null;
          //var val = parseInt(0, 10);
          //selectItem.selectedIndex = 0;
          //console.log(selectItem.selectedIndex);
          //var val = parseInt(inp.value, 10);
          //sel.selectedIndex = val;
          //e.target.removeListeners();
        })
      });
    }
  }
}

App.init();

